<!-- Main container -->
<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [interactionMode]="'selection'"
    (itemClick)="onItemClick($event)"
    (selectionSingleChange)="onSelectionSingleChange($event)"
    (selectionChange)="onSelectionChange($event)"
  >
    <!-- type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'context.type' | translate }}</th>
      <td mat-cell *matCellDef="let prodOrderTransit">
        <div class="layout-col">
          <span class="text-body-medium" [matTooltip]="prodOrderTransit.id">
            {{ 'transit.orders.types.' + prodOrderTransit.type | translate }}
          </span>
        </div>
      </td>
    </ng-container>

    <!-- involved facilities Column -->
    <ng-container matColumnDef="sourceFacilityId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="sourceFacilityId">
        {{ 'facilities.facilities' | translate }}
      </th>
      <td mat-cell *matCellDef="let prodOrderTransit">
        <div class="layout-row gap-sm place-start-center">
          <span>{{ prodOrderTransit.sourceFacilityId }}</span>
          <mat-icon>arrow_right_alt</mat-icon>
          <span>{{ prodOrderTransit.targetFacilityId }}</span>
        </div>
      </td>
    </ng-container>
  </elder-table>
</div>
